export const messageHistoryCopyDa = {
    title: "Beskedhistorik",
    noMessages: "Ingen beskeder fundet",
    viewMessages: "Vis beskeder",
    to: "Til:",
    from: "Fra:",
    subject: "Emne:",
    statusClicked: "Klikket",
    statusRead: "Læst",
    statusReadAt: "kl.",
    statusDelivered: "Leveret",
    statusSent: "Sendt",
    statusPending: "Afventer",
    channelEmail: "E-mail",
    channelSms: "SMS",
    retentionNotice: "Beskeder opbevares kun i 30 dage",
};
